import { render } from "./CatAlmacenView.vue?vue&type=template&id=b4247c54&scoped=true"
import script from "./CatAlmacenView.vue?vue&type=script&lang=js"
export * from "./CatAlmacenView.vue?vue&type=script&lang=js"

import "./CatAlmacenView.vue?vue&type=style&index=0&id=b4247c54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4247c54"]])

export default __exports__